import { push } from "connected-react-router";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OrganizerHeader } from "../components/header";
import { SmallButton } from "../components/UIkit";
import { getCurrentUser, getUserId } from "../reducks/users/selectors";
import "../assets/css/profileBox.css";
import "../assets/css/organizerPage.css";
import { fechCurrentUser } from "../reducks/users/operations";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { makeStyles } from "@material-ui/styles";
import { fetchMyBooths } from "../reducks/booths/operations";
import { getBooths } from "../reducks/booths/selectors";
import { MyBoothCard } from "../components/mypage";
import "date-fns";
import { getMyOpuses } from "../reducks/opuses/selectors";
import { fetchMyOpuses } from "../reducks/opuses/operations";
import { OpusCard } from "../components/opuses";
import { hideLoadingAction, showLoadingAction } from "../reducks/loading/actions";
import FooterBox from "../components/footer/FooterBox";
import GuestImage from "../assets/img/src/no-profile.png";

const useStyles = makeStyles({
  icon: {
    height: 35,
    width: 35,
    color: "#25677b",
    position: "absolute",
    right: 0,
    bottom: 0,
  },
});

const OrganizerPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const opuses = getMyOpuses(selector);
  const currentUser = getCurrentUser(selector);
  const booths = getBooths(selector);
  const isBoothEditing = true;
  const isOpusEditing = true;

  useEffect(() => {
    dispatch(fetchMyBooths(uid));
    dispatch(fechCurrentUser(uid));
    dispatch(fetchMyOpuses(uid));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    dispatch(showLoadingAction());
    dispatch(fechCurrentUser(uid));
    dispatch(hideLoadingAction());
    // eslint-disable-next-line
  }, [uid]);

  return (
    <>
      <section>
        <div className="common-container">
          <div className="common-container__header--inner center center-box">
            <OrganizerHeader isBoothEditing={isBoothEditing} isOpusEditing={isOpusEditing} />
            <div className="mypage-container">
              {currentUser && (
                <>
                  <div className="spacer-box--m" />
                  <div className="organizer-headline ">プロフィール</div>
                  <div className="spacer-box--s" />
                  <div className="avatar-preview-position center">
                    <div className="hover1">
                      <AddPhotoAlternateIcon
                        className={classes.icon}
                        onClick={() => dispatch(push(`/avatar/edit/${uid}`))}
                      />
                    </div>
                    {typeof currentUser.avatar !== "undefined" ? (
                      <img className="avatar-trim--profile" src={currentUser.avatar} alt="アバター画像" width="80" />
                    ) : (
                      <img className="avatar-trim" src={GuestImage} alt="アバター画像" width="50" />
                    )}
                  </div>
                  <div className="spacer-box--s" />
                  <div className="organizer-section-headline yu-gothic">Name</div>
                  <div className="organizer-basic-text yu-gothic">{currentUser.username}</div>
                  {currentUser.genre && (
                    <>
                      <div className="spacer-box--s" />
                      <div className="organizer-section-headline yu-gothic">Genre</div>
                      <div className="organizer-basic-text yu-gothic">{currentUser.genre}</div>
                    </>
                  )}
                  {currentUser.intro && (
                    <>
                      <div className="spacer-box--s" />
                      <div className="organizer-intro-box center-box">
                        <div className="organizer-section-headline yu-gothic">Introduced</div>
                        <div className="spacer-box--ss" />
                        <div className="center">
                          <div className="left inline-block organizer-intro-text yu-gothic ">{currentUser.intro}</div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="spacer-box--m" />
                  <SmallButton label="編集する" onClick={() => dispatch(push(`/profile/edit/${uid}`))} />
                  <div className="spacer-box--l" />
                  <div className="spacer-box--l" />
                </>
              )}
              <div className="organizer-headline ">ブース管理</div>
              <div className="spacer-box--m" />
              {booths.length !== 0 ? (
                <>
                  <SmallButton label="+ブース追加" onClick={() => dispatch(push("/booth/edit/"))} />
                  <div className="spacer-box--s" />
                  <div className="grid__row">
                    {booths.map((booth) => (
                      <div key={booth.id}>
                        <div>
                          <MyBoothCard
                            id={booth.id}
                            selectOpuses={booth.selectOpuses}
                            boothName={booth.boothName}
                            organizerName={booth.organizerName}
                            isBlack={booth.isBlack}
                            isGothic={booth.isGothic}
                            liveDay={booth.liveDay}
                            liveTime={booth.liveTime}
                          />
                          <div className="spacer-box--l"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="organizer-basic-text yu-gothic">まだ登録がありません</div>
                  <div className="spacer-box--s"></div>
                  <SmallButton label="ブース作成" onClick={() => dispatch(push("/booth/edit/"))} />
                </>
              )}
              <div className="spacer-box--l" />
              <div className="spacer-box--l" />
              <div className="organizer-headline ">作品管理</div>

              <div className="spacer-box--m" />
              {opuses.length !== 0 ? (
                <>
                  <SmallButton label="+作品追加" onClick={() => dispatch(push("/opus/edit/"))} />
                  <div className="spacer-box--m" />
                  <div className="grid__row">
                    {opuses.map((opus) => (
                      <div key={opus.id}>
                        <OpusCard key={opus.id} id={opus.id} images={opus.images} price={opus.price} name={opus.name} />
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="organizer-basic-text yu-gothic">まだ登録がありません</div>
                  <div className="spacer-box--ss"></div>
                  <SmallButton label="作品登録" onClick={() => dispatch(push("/opus/edit/"))} />
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <FooterBox />
    </>
  );
};

export default OrganizerPage;
